export function capitalize(val) {
  let str = val;
  try {
    str = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  } catch(ex) {console.log(ex)}

  return str;
}